import useLeadQuotaMetricColumns from "./useLeadQuotaMetricColumns";
import { Quota } from "src/app/types/quota";
import { BaseAgGrid } from "../grid/BaseAgGrid";
import { SelectionChangedEvent, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useRef, useCallback } from "react";

export interface ILeadQuotaMetricGrid {
    quotaList?: Array<Quota>;
    setSelectedRows?: React.Dispatch<React.SetStateAction<any[]>>;
    isLead?: boolean;
}

const LeadQuotaMetricGrid = (props: ILeadQuotaMetricGrid) => {
    const { quotaList = [], setSelectedRows = () => {} } = props;
    const keys = Object.keys(quotaList[0] || []);
    const gridRef = useRef<AgGridReact>(null);
    const gridColumns = useLeadQuotaMetricColumns(keys);

    const onSelectionChanged = (event: SelectionChangedEvent) => {
        setSelectedRows(event.api.getSelectedRows());
    };
    const onGridReady = useCallback((params: GridReadyEvent) => {
        const gridApi = params.api;
        gridApi.sizeColumnsToFit();

        //init filters
        window.addEventListener("resize", function () {
            if (gridRef?.current?.api) {
                setTimeout(function () {
                    gridRef?.current?.api.sizeColumnsToFit();
                });
            }
        });

        gridApi.setRowData(quotaList);
    }, []);

    const doesExternalFilterPass = useCallback((): boolean => {
        return true;
    }, []);

    return (
        <div className="ag-theme-balham" style={{ height: "100%" }}>
            <BaseAgGrid
                rowSelection="single"
                listHandler={() => {}}
                sideBar={null}
                onSelectionChanged={onSelectionChanged}
                gridRef={gridRef}
                columnDefs={gridColumns}
                isExternalFilterPresent={() => true}
                onModelUpdated={() => {}}
                doesExternalFilterPass={doesExternalFilterPass}
                onGridReady={onGridReady}
            />
        </div>
    );
};

export default LeadQuotaMetricGrid;
